import { render, staticRenderFns } from "./CanvasQuestionImage.vue?vue&type=template&id=b62e9350&scoped=true&"
import script from "./CanvasQuestionImage.vue?vue&type=script&lang=js&"
export * from "./CanvasQuestionImage.vue?vue&type=script&lang=js&"
import style0 from "./CanvasQuestionImage.vue?vue&type=style&index=0&id=b62e9350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62e9350",
  null
  
)

export default component.exports